import {ThemeOptions} from '@mui/material';
import {merge} from 'lodash';
import {themePoppins} from './themePoppins';

export const themeDarkPoppinsAero = merge({}, themePoppins, {
   palette: {
      mode: 'dark',
      primary: {main: '#3eabd1'},
      secondary: {main: '#00bcd4'},
      background: {
         default: '#0f172a', // deep navy background
         paper: 'rgba(30, 41, 59, 0.7)', // glass-like card
      },
      text: {
         primary: '#f1f5f9',
         secondary: '#94a3b8',
      },
      divider: 'rgba(255, 255, 255, 0.08)',
   },

   shape: {
      borderRadius: 8,
   },

   typography: {
      fontFamily: '"Poppins", "Roboto", sans-serif',
      h1: {fontWeight: 700},
      h2: {fontWeight: 600},
   },

   components: {
      MuiCssBaseline: {
         styleOverrides: {
            // Use a fixed background container
            'body, html': {
               height: '100%',
               margin: 0,
               padding: 0,
               overflowX: 'hidden',
               // backgroundColor: '#0f172a',
            },

            body: {
               position: 'relative',
               color: '#f1f5f9',
            },

            // Create static background layer (not scrolling)
            'body::before': {
               content: '""',
               position: 'fixed',
               inset: 0,
               zIndex: -1,
               backgroundImage: `
            radial-gradient(at 40% 20%, rgba(62,171,209,0.15) 0px, transparent 50%),
            radial-gradient(at 80% 0%, rgba(0,188,212,0.1) 0px, transparent 50%),
            radial-gradient(at 0% 50%, rgba(0,86,179,0.08) 0px, transparent 50%)
          `,
               // backgroundColor: '#0f172a',
               backgroundAttachment: 'fixed',
               backgroundRepeat: 'no-repeat',
               backgroundSize: 'cover',
               pointerEvents: 'none',
            },

            // Floating panel animation
            '.Panel-root': {
               transition:
                  'transform 400ms cubic-bezier(0.25, 0.8, 0.25, 1), box-shadow 400ms cubic-bezier(0.25, 0.8, 0.25, 1)',
               transform: 'translateY(0)',
               boxShadow: '0px 1px 6px -3px rgba(0,0,0,0.4)',
               background: 'rgba(30, 41, 59, 0.7)',
               border: '1px solid rgba(255,255,255,0.08)',
               backdropFilter: 'blur(12px)',
            },

            '.Panel-root:has(:focus), .Panel-root:hover': {
               transform: 'translateY(-4px)',
               boxShadow: '0px 8px 24px -6px rgba(62, 171, 209, 0.45)',
               borderColor: 'rgba(62, 171, 209, 0.4)',
            },
         },
      },

      MuiOutlinedInput: {
         styleOverrides: {
            root: {
               '&.Mui-disabled': {
                  background: '#000',
               },
            },
         },
      },

      MuiPaper: {
         styleOverrides: {
            root: {
               backdropFilter: 'blur(12px)',
               backgroundImage: 'linear-gradient(145deg, rgba(30,41,59,0.85), rgba(15,23,42,0.85))',
               border: '1px solid rgba(255,255,255,0.08)',
               transition: 'background 0.4s ease',
            },
         },
      },

      MuiButton: {
         styleOverrides: {
            root: {
               borderRadius: 6,
               textTransform: 'none',
               fontWeight: 600,
               transition: 'all 0.25s ease',
               color: '#f1f5f9',
               '&:hover': {
                  transform: 'translateY(-2px)',
                  boxShadow: '0 4px 12px rgba(62,171,209,0.25)',
                  backgroundColor: 'rgba(62,171,209,0.15)',
               },
               '&:active': {
                  transform: 'translateY(0px) scale(0.98)',
                  backgroundColor: 'rgba(62,171,209,0.25)',
               },
            },
         },
      },
   },
}) as ThemeOptions;
